//#region ../base/config/index.ts
/**
* Maintains a mutable config object with a get and set method.
*/
var ConfigBase = class {
	getConfig;
	config;
	constructor(getConfig) {
		this.getConfig = getConfig;
	}
	initialize(env) {
		this.config = this.getConfig(env);
	}
	/**
	* Get a copy of the config object
	*/
	get() {
		if (typeof this.config === "undefined") throw new Error("Companion config has not been initialized!");
		return {
			...this.config,
			...JSON.parse(JSON.stringify(this.config))
		};
	}
	/**
	* Returns a function that always gets the latest state from the config based on the given selector.
	*
	* @example
	* ```ts
	* const getSomeConfValue = config.select((conf) => {
	*   return conf.someValue;
	* });
	*
	* getSomeConfValue(); // returns `conf.someValue`
	* ```
	*/
	select(selector) {
		return () => selector(this.get());
	}
	/**
	* Update configuration object by mutation
	*
	* Pass a function that receives a copy of the current config.
	* Any mutations to this copy will be applied as the new config object.
	*
	* @example
	* ```ts
	* config.set((existingConfig) => {
	*   existingConfig.someProp = 1234;
	*   existingConfig.nested.prop = 'abcd';
	* })
	* ```
	*/
	set(updateConfig) {
		const configCopy = this.get();
		updateConfig(configCopy);
		this.config = Object.assign(this.config ?? {}, configCopy);
	}
};

//#endregion
export { ConfigBase };